export default "__VITE_ASSET__C2dpN7xZ__"